package com.evoapps.evoshift.data.dto.workplace

import kotlinx.serialization.Serializable

@Serializable
data class RecurringCostRuleDto(
    val uid: String,
    val name: String,
    val amount: Double,
    val currency: String,
    val frequency: CostFrequencyDto,
    val targetWorkplaceId: String,
    /** SH-87: "COST" or "REVENUE"; rules from before SH-87 have none (a cost). */
    val kind: String = "COST"
)

@Serializable
enum class CostFrequencyDto {
    MONTHLY,
    WEEKLY,
    YEARLY,
    ONE_OFF
}
